'use strict';

exports.__esModule = true;
exports.TableViewChoseColumns = exports.styles = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MoreVert = require('material-ui-icons/MoreVert');

var _MoreVert2 = _interopRequireDefault(_MoreVert);

var _Tooltip = require('material-ui/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Menu = require('material-ui/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _ListItem = require('material-ui/List/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ListItemText = require('material-ui/List/ListItemText');

var _ListItemText2 = _interopRequireDefault(_ListItemText);

var _Switch = require('material-ui/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = {
  root: {}
};

var TableViewChoseColumns = exports.TableViewChoseColumns = function (_Component) {
  _inherits(TableViewChoseColumns, _Component);

  function TableViewChoseColumns() {
    var _temp, _this, _ret;

    _classCallCheck(this, TableViewChoseColumns);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      anchorEl: null
    }, _this.handleClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    }, _this.handleClose = function () {
      _this.setState({
        anchorEl: null
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TableViewChoseColumns.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        columnData = _props.columnData,
        toggleColumnVisibility = _props.toggleColumnVisibility;

    if (!columnData || !columnData.length) {
      return null;
    }

    var ITEM_HEIGHT = 48;
    var anchorEl = this.state.anchorEl;
    var columns = [];
    columnData.map(function (n, index) {
      var id = n.id,
          label = n.label,
          description = n.description,
          hidden = n.hidden;

      if (hidden === undefined) {
        return;
      }

      var textPrimary = label || id;
      var checked = hidden === true ? false : true;
      columns.push(_react2.default.createElement(_ListItem2.default, {
        key: index,
        dense: true,
        button: true,
        onClick: function onClick(event) {
          return toggleColumnVisibility(event, !checked, index);
        }
      }, _react2.default.createElement(_Switch2.default // onChange={(event, checked) => toggleColumnVisibility(event, checked, index)}
      , {
        checked: checked
      }), _react2.default.createElement(_ListItemText2.default, {
        primary: textPrimary,
        secondary: description
      })));
    });

    if (!columns || !columns.length) {
      return null;
    }

    return _react2.default.createElement('div', null, _react2.default.createElement(_IconButton2.default, {
      'aria-label': 'More',
      'aria-owns': anchorEl ? 'long-menu' : null,
      'aria-haspopup': 'true',
      onClick: this.handleClick
    }, _react2.default.createElement(_MoreVert2.default, null)), _react2.default.createElement(_Menu2.default, {
      id: 'long-menu',
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClose: this.handleClose,
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          minWidth: 200,
          maxWidth: 350
        }
      }
    }, columns));
    return _react2.default.createElement(_Tooltip2.default, {
      title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u043E\u043B\u043E\u043D\u043A\u0438"
    }, _react2.default.createElement(_IconButton2.default // aria-label="AddPlace"
    // onClick={addObject}
    , null, _react2.default.createElement(_MoreVert2.default, null)));
  };

  return TableViewChoseColumns;
}(_react.Component);

TableViewChoseColumns.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  columnData: _propTypes2.default.array.isRequired,
  toggleColumnVisibility: _propTypes2.default.func.isRequired
} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TableViewChoseColumns, props);
});